import { UntypedFormControl } from "@angular/forms";
import { isWebUri } from "valid-url";

export const validateUrl = (formControl: UntypedFormControl) => {
  const value = formControl.value as string;
  if (!value) {
    return null;
  }
  try {
    const check = isWebUri as unknown as (v: string) => string | undefined;
    const result = check(value);
    return result ? null : { urlInvalid: true };
  } catch {
    return { urlInvalid: true };
  }
};

export const validateHTTPExists = (formControl: UntypedFormControl) => {
  const value = formControl.value as string;
  if (!value) {
    return null;
  }
  return /^((http|https):\/\/)/.test(value) ? { httpExists: true } : null;
};
